(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
// Newsletter form submission handling
document.querySelector('.newsletter-form form').addEventListener('submit', function(e) {
  e.preventDefault();
  // Add your form submission logic here
  console.log('Form submitted');
});

  } catch(e) { console.error(e); }
})();
})();
